import { VENDOR_STATUSES } from "../endpoints";
import api from "../api";

export default {
    index() {
        return api.get(VENDOR_STATUSES);
    }
}